export const ACCOUNT_POST_MISSING_POINTS = 'ACCOUNT_POST_MISSING_POINTS';
export const ACCOUNT_POST_MISSING_POINTS_SUCCESS = 'ACCOUNT_POST_MISSING_POINTS_SUCCESS';
export const ACCOUNT_POST_MISSING_POINTS_ERROR = 'ACCOUNT_POST_MISSING_POINTS_ERROR';
export const ACCOUNT_CLEAR_MISSING_POINTS = 'ACCOUNT_CLEAR_MISSING_POINTS';
export const GET_MISSING_POINTS_DETAILS = 'GET_MISSING_POINTS_DETAILS';
export const ACCOUNT_TRACK_OPEN_MISSING_MODAL_SUCCESS = 'ACCOUNT_TRACK_OPEN_MISSING_MODAL_SUCCESS';
export const ACCOUNT_TRACK_OPEN_MISSING_MODAL_ERROR = 'ACCOUNT_TRACK_OPEN_MISSING_MODAL_ERROR';
